"use client";

import dynamic from 'next/dynamic';

const HandPicked3 = dynamic(() => import('./handpicked-3'), { ssr: false });

export default function HandPickedWrapper1() {
    return (
        <>
            <HandPicked3 id="3" />
        </>
    );
}